import { render, staticRenderFns } from "./titem.vue?vue&type=template&id=49af4820&scoped=true"
import script from "./titem.vue?vue&type=script&lang=ts"
export * from "./titem.vue?vue&type=script&lang=ts"
import style0 from "./titem.vue?vue&type=style&index=0&id=49af4820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49af4820",
  null
  
)

export default component.exports